import { IsDefined, IsIn, IsInt, IsISO8601 } from 'class-validator';

export class UpdateCashUpDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsIn(['cash', 'card', 'float'])
  type: string;

  @IsDefined()
  @IsISO8601()
  day: string;

  @IsDefined()
  @IsInt()
  currencyId: number;
}
